import { Col, Row } from "react-bootstrap";
import { IFullLicenceDetails } from "../../../../api/LicenceDetails";
import EpaCard from "../../../../leap-components/EpaCard";
import EpaField from "../../../../leap-components/EpaField";

interface LicenceDetailsProps {
  licence: IFullLicenceDetails;
}

const Assessment = ({ licence }: LicenceDetailsProps) => {
  var bodyElements = (
    <div>
      <Row>
        <Col className="col-12 col-md-12">
          <EpaField
            label={"AA Screening Complete"}
            value={licence.aascreeningcompleted}
          />
          <EpaField
            label={"AA Screening Result"}
            value={licence.aascreeningresult}
          />
          <EpaField
            label={"EIA Screening Complete"}
            value={licence.eiascreeningcompleted}
          />
          <EpaField
            label={"EIA Screening Result"}
            value={licence.eiascreeningresult}
          />
          <EpaField
            label={"EIAR Received Date"}
            value={licence.eiareceiveddate}
          />
          <EpaField
            label={"EIAR in Compliance"}
            value={licence.eiarincompliance}
          />
          <EpaField
            label={"Submission Count"}
            value={licence.submissioncount}
          />
          <EpaField label={"Objection Count"} value={licence.objectioncount} />
        </Col>
      </Row>
    </div>
  ) as JSX.Element;

  return <EpaCard title={"Assessment"} content={bodyElements} />;
};

export default Assessment;
